import { getTokenEndpoint, type KeycloakConfig, type KeycloakTokenResponse } from './config';

const requestTokens = async (config: KeycloakConfig, body: URLSearchParams): Promise<KeycloakTokenResponse> => {
  const response = await fetch(getTokenEndpoint(config.issuer), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body,
  });

  if (!response.ok) {
    throw new Error('token_exchange_failed');
  }

  return (await response.json()) as KeycloakTokenResponse;
};

export const exchangeAuthorizationCode = async (code: string, config: KeycloakConfig, codeVerifier: string): Promise<KeycloakTokenResponse> =>
  requestTokens(
    config,
    new URLSearchParams({
      grant_type: 'authorization_code',
      code,
      client_id: config.clientId,
      redirect_uri: config.redirectUri,
      code_verifier: codeVerifier,
    })
  );

export const refreshKeycloakTokens = async (refreshToken: string, config: KeycloakConfig): Promise<KeycloakTokenResponse> =>
  requestTokens(
    config,
    new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: config.clientId,
      refresh_token: refreshToken,
    })
  );
